import { put, all, takeLatest } from 'redux-saga/effects';
import { handleApiCall } from '../SagaUtils';
import { push } from 'react-router-redux';

import {
  FETCH_ACCOUNT_GROUPS,
  FETCH_ACCOUNT_GROUP,
  UPDATE_ACCOUNT_GROUP,
  CREATE_ACCOUNT_GROUP,
  MODAL_OPEN,
  MODALS
} from '../../constants/Constants';
import * as Api from '../../services/Api';

function* fetchAccountGroups() {
  yield handleApiCall(FETCH_ACCOUNT_GROUPS, Api.fetchAccountGroups, true);
}

function* fetchAccountGroup({ payload: { groupId } }) {
  yield handleApiCall(FETCH_ACCOUNT_GROUP, Api.fetchAccountGroup, true, groupId);
}

function* createAccountGroup({ payload }) {
  const res = yield handleApiCall(CREATE_ACCOUNT_GROUP, Api.createAccountGroup, true, payload);
  if (res) {
    yield put(push('/settings/accounts/groups'));
  }
}

function* updateAccountGroup({ payload }) {
  yield handleApiCall(UPDATE_ACCOUNT_GROUP, Api.updateAccountGroup, true, payload);
}

function* handleSaveError() {
  yield put({ type: MODAL_OPEN, payload: { id: MODALS.ACCOUNT_GROUP_SAVE_CONFIRM } });
}

export default function* accountGroupsSaga() {
  yield all([
    yield takeLatest(FETCH_ACCOUNT_GROUPS.REQUESTED, fetchAccountGroups),
    yield takeLatest(FETCH_ACCOUNT_GROUP.REQUESTED, fetchAccountGroup),
    yield takeLatest(CREATE_ACCOUNT_GROUP.REQUESTED, createAccountGroup),
    yield takeLatest(UPDATE_ACCOUNT_GROUP.REQUESTED, updateAccountGroup),
    yield takeLatest(UPDATE_ACCOUNT_GROUP.ERROR, handleSaveError),
    yield takeLatest(CREATE_ACCOUNT_GROUP.ERROR, handleSaveError)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/entities/AccountGroupsSaga.js